var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',_vm._l((_vm.items),function(item){return _c(_vm.resolveNavItemComponent(item),{key:item.header || item.title,tag:"component",attrs:{"updateMouseHovered":_vm.updateMouseHovered,"item":item,"is-updated":_vm.isUpdated}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }